import './axios.interceptors'
import './app.css'
import 'dayjs/locale/fr'
import '@fortawesome/fontawesome-free/css/fontawesome.css'
import '@fortawesome/fontawesome-free/css/brands.css'
import '@fortawesome/fontawesome-free/css/solid.css'
import * as Sentry from '@sentry/vue'
import { createApp } from 'vue'

import App from './App.vue'
import { i18n } from './i18n/i18n'
import router from './router'

const app = createApp(App)

/** An empty build variable means "not set": Sentry then derives no release. */
function nonEmpty(value: string | undefined): string | undefined {
  return value != null && value !== '' ? value : undefined
}

// Sentry integration, login dev@code-troopers
if (!import.meta.env.DEV) {
  Sentry.init({
    app,
    dsn: 'https://c48139fcffa14ba5a9560e8afbf8157c@o100126.ingest.us.sentry.io/1301118',
    // one image serves every client: the host tells them apart (itg, pp, <client>.chapi.to)
    environment: window.location.hostname,
    // set by the CI at the docker build (tag, or commit when untagged)
    release: nonEmpty(import.meta.env.VITE_APP_RELEASE),
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
    ],

    // 10% of the page loads are traced: performance monitoring without
    // sending a transaction on every page load
    tracesSampleRate: 0.1,

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })
}

app.use(router)
app.use(i18n)
app.mount('#app')
